// removed by extract-text-webpack-plugin
module.exports = {"deleteDialog":"DeleteModal__deleteDialog__3_HUP","buttons":"DeleteModal__buttons__SVTAn","warning":"DeleteModal__warning__1taUJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/DeleteModal/DeleteModal.scss
// module id = 1682
// module chunks = 0